module.exports = __webpack_public_path__ + "static/media/PairTiles.c08477e8.jpg";